import { combineReducers } from '@reduxjs/toolkit';
import { createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import {
  persistReducer as createPersistReducer,
  persistStore,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
  applicationSettingsSlice,
  authSlice,
  filtersSlice,
} from '@lon/shared/configs';
import sidebarReducer from './sidebar';
import standardReducer from './standard';
import assessmentsReducer from './assessments';

const imageTag = process.env?.['NX_IMAGE_TAG'] || '';

const persistConfig = {
  key: `platform-admin[${imageTag}]`,
  storage,
  whitelist: ['filters'],
  blacklist: ['auth'],
};

const reducer = combineReducers({
  auth: authSlice.default,
  filters: filtersSlice.default,
  sidebar: sidebarReducer,
  assessments: assessmentsReducer,
  applicationSettings: applicationSettingsSlice.default,
  standard: standardReducer,
});

const persistReducer = createPersistReducer(persistConfig, reducer);

export const store = createStore(persistReducer, composeWithDevTools());

export const persistor = persistStore(store);

export * from './types';
export * from './assessments';
export * from './standard';

export default reducer;
